import { useEffect, useState } from 'react';
import { api } from '../api/client';
import type { AnalystAssumption } from '../types';

export function AuditLogPanel() {
  const [rows, setRows] = useState<AnalystAssumption[]>([]);

  const load = () => {
    api.auditLog(50).then(setRows).catch(console.error);
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
        <h3 style={{ margin: 0 }}>Analyst Assumption Log</h3>
        <button className="btn secondary" type="button" style={{ padding: '0.25rem 0.6rem', fontSize: '0.75rem' }} onClick={load}>
          Refresh
        </button>
      </div>
      {rows.length === 0 ? (
        <p style={{ color: '#6b7280', fontSize: '0.85rem', margin: 0 }}>No analyst changes recorded yet.</p>
      ) : (
        <table className="data-table">
          <thead>
            <tr><th>Time</th><th>Variable</th><th>Field</th><th>Old</th><th>New</th><th>Note</th></tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td>{r.timestamp?.slice(0, 19)}</td>
                <td>{r.variable_id}</td>
                <td>{r.field_changed}</td>
                <td>{r.old_value ?? '—'}</td>
                <td>{r.new_value ?? '—'}</td>
                <td>{r.analyst_note ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
